import { ValidatorFn, FormControl } from '@angular/forms';

// custom validator to check that two fields match
export const checkChecked: ValidatorFn = (control: FormControl) => {
  if (control && control.value) {
    return null;
  }
  return { checkChecked: true };
};
